package com.damda.design_system.ui.views.core

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.damda.design_system.core.ImageResourceLoader
import com.damda.design_system.ui.screens.HedgehogRouter
import com.damda.design_system.ui.screens.JSScreen
import com.damda.design_system.ui.viewmodels.FoodCartState
import com.damda.design_system.ui.views.compose_migrations.layouts.JSColumn
import com.damda.design_system.ui.views.compose_migrations.layouts.JSFooter
import com.damda.design_system.ui.views.compose_migrations.layouts.NavBar
import com.damda.design_system.ui.views.web.MainPage
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.boxSizing
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.overflow
import org.jetbrains.compose.web.css.overflowY
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div

@Composable
actual fun MyApp(
    windowSize: ComposeWindowWidthSizeClass,
    imageResourceLoader: ImageResourceLoader
) {
    HedgehogWebScreen(windowSize, imageResourceLoader)
}

@Composable
fun HedgehogWebScreen(
    windowSize: ComposeWindowWidthSizeClass,
    imageResourceLoader: ImageResourceLoader
) {
    val screen = mutableStateOf<JSScreen>(JSScreen.Home)
    val cartState = remember { FoodCartState() }
    Div ({
        style {
            width(100.percent) // Viewport width
            margin(0.px) // Remove margin
            padding(0.px)
            boxSizing("border-box")
        }
    }){
        JSColumn {
            NavBar()
            Div (
                {
                    style {
                        width(100.percent)
                        overflow("hidden") // 부모 요소를 넘어가는 부분을 숨기기
                        boxSizing("border-box")
                    }
                }
            ){
                if (windowSize == ComposeWindowWidthSizeClass.Large) {
                    MainPage {
                        Div (attrs ={
                            style {
                                width(420.px)
                                height(680.px)
                                backgroundColor(Color.white)
                                borderRadius(16.px)
                                property("box-shadow", "0px 4px 4px rgba(0, 0, 0, 0.25)")
                                overflowY("auto") // 세로 스크롤 가능하게 설정
                            }
                            style {
                                // 수평 및 수직 스크롤바 숨기기
                                property("-ms-overflow-style", "none") // IE and Edge
                                property("scrollbar-width", "none") // Firefox
                                property("::-webkit-scrollbar", "display:none") // Chrome, Safari, Opera
                            }
                        }){
                            HedgehogRouter(windowSize, cartState, screen.value) {
                                screen.value = it
                                scrollToTop()
                            }
                        }
                    }
                } else {
                    HedgehogRouter(windowSize, cartState, screen.value) {
                        screen.value = it
                        scrollToTop()
                    }
                }
            }
            JSFooter()
        }
    }
}

fun scrollToTop() {
    js("window.scrollTo(0, 0)")
}